<template>
    <div>
        <!-- Input Form -->
        <form v-if="!calculated" @submit.prevent="submit">
            <div class="form-group">
                <label>Have you or anyone from your house bought electricity this month? </label>
                <select
                    v-model="form.bought"
                    :class="['custom-select', form.errors.get('bought') ? 'is-invalid' : '']"
                >
                    <option value="no">No, This is the first time this month.</option>
                    <option value="yes">Yes, we have bought some ZESA this month.</option>
                </select>
                <div v-text="form.errors.get('bought')" class="invalid-feedback"></div>
            </div>

            <div class="form-group">
                <label>What would you like to calculate? </label>
                <select
                    v-model="form.currency"
                    :class="['custom-select', form.errors.get('currency') ? 'is-invalid' : '']"
                >
                    <option value="ZWG">Number of units my money can buy.</option>
                    <option value="UNITS">How much it will cost to buy my units.</option>
                </select>
                <div v-text="form.errors.get('currency')" class="invalid-feedback"></div>
            </div>

            <div class="form-group" v-if="form.bought === 'yes'">
                <label>How many Units have you bought this month?</label>
                <input
                    type="text"
                    v-model="form.previous"
                    :class="['form-control', form.errors.get('previous') ? 'is-invalid' : '']"
                    placeholder=""
                />
                <div v-text="form.errors.get('previous')" class="invalid-feedback"></div>
            </div>

            <div class="form-group">
                <label v-if="form.currency === 'ZWG'">
                    How much would you like to pay [ {{ form.currency }} ]?
                </label>
                <label v-else>How many units do you want to buy?</label>
                <input
                    type="text"
                    v-model="form.amount"
                    :class="['form-control', form.errors.get('amount') ? 'is-invalid' : '']"
                    placeholder=""
                />
                <div v-text="form.errors.get('amount')" class="invalid-feedback"></div>
            </div>

            <div class="form-group">
                <button
                    :class="['btn btn-primary btn-block', form.loading ? 'btn-loading' : '']"
                >
                    Crunch the Numbers
                </button>
            </div>
        </form>

        <!-- Results Section -->
        <div v-if="calculated" class="result-container slide-in-left mt-4 text-center">
            <h5 style="font-size: 0.9rem;">Based on what you've told us</h5>
            <div class="alert alert-success text-center">
                <!-- <h5>Calculation Result</h5> -->
                <p v-if="form.currency === 'ZWG'" class="mb-0">
                    <span style="font-size: 1.2rem;">You can get</span>
                    <span class="d-block font-weight-bold" style="font-size: 1.8rem; line-height: 1;">
                        {{ result.units }} units
                    </span>
                    for <b>ZWG {{ result.zwl }}</b>
                </p>

                <p v-else class="mb-0">
                    <span style="font-size: 1.2rem;">You will need</span>
                    <span class="d-block font-weight-bold" style="font-size: 1.8rem; line-height: 1;">
                        ZWG {{ result.zwl.toFixed(2) }}
                    </span>
                    to buy <b> {{ result.units }} units</b>
                </p>
            </div>

            <div class="alert alert-primary text-center">

                <!-- Breakdown Section -->
                <div class="mt-3 text-center">
                    <div>
                        <span class="d-block font-weight-bold" style="font-size: 1.2rem;">
                            COST BREAKDOWN
                        </span>

                        <div style="font-size: 1rem;">

                            <div class="mt-2">
                                <strong>Total Cost<br></strong>
                                ZWG {{ result.zwl.toFixed(2) }}
                            </div>

                            <div class="mt-3">
                                <strong>Energy Charge<br></strong>
                                ZWG {{ result.charge.toFixed(2) }}
                            </div>

                            <div class="mt-3">
                                <strong>RE Levy<br></strong>
                                ZWG {{ result.re_levy.toFixed(2) }}
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <button @click="reset" class="btn btn-secondary btn-block">
                Perform Another Calculation
            </button>
        </div>
    </div>
</template>



<script>
import Form from "../../../../core/forms/form";
import WelcomeInfo from "../../../shared/welcome-info.vue";
import BillShell from "../../bill-shell.vue";
import TariffsTable from "../../../custom/tariffs-table.vue";

export default {
    name: "dashboard",
    components: {TariffsTable, BillShell, WelcomeInfo},
    data: function () {
        return {
            calculated: false,
            fields: [
                'bought',
                'currency',
                'amount',
            ],
            result: {
                units: 0,
                zwl: 0,
                charge: 0,
                re_levy: 0,
                output: []
            },
            form: new Form({
                'bought': 'no',
                'currency': 'ZWG',
                'amount': '',
                'previous': '',
            })
        };
    },

    methods: {

        reset() {
            this.form.bought = 'no';
            this.form.currency = 'ZWG';
            this.form.amount = '';
            this.form.previous = '';
            this.calculated = false;
        },

        saveToLocalStorage() {
            // for (let i = 0; i < this.fields.length; i++)
            // {
            //     localStorage.setItem(this.fields[i] , this.form[this.fields[i]]);
            // }
        },

        getFromLocalStorage() {
            // for (let i = 0; i < this.fields.length; i++)
            // {
            //     let value = localStorage.getItem(this.fields[i]);
            //     if (  value != null &&  value !== "" && value !== "null")
            //     {
            //         this.form[this.fields[i]] = value;
            //     }
            // }
        },

        submit() {
            // Save to Local Storage

            this.form.submit('/bills/zesa/calculator').then((response) => {
                this.result.units = response.data.units;
                this.result.zwl = response.data.totalZWG;
                this.result.charge = response.data.energy_charge;
                this.result.re_levy = response.data.re_levy;
                this.result.output = response.data.output;

                console.log('Response:', response.data);

                this.$nextTick(() => {
                    this.calculated = true;
                });
            });
        }
    },

    mounted() {
        // Check in Local Storage
        this.getFromLocalStorage();
    }
}
</script>

<style scoped>
@keyframes slideInLeft {
    from {
        transform: translateX(-100%);
        opacity: 0;
    }
    to {
        transform: translateX(0);
        opacity: 1;
    }
}

.slide-in-left {
    animation: slideInLeft 0.5s ease-in-out;
}
</style>
